import React from "react";
import InitialPropsContext from "../lib/models/initialPropsContext";
import PageNotFoundError from "../lib/pageNotFoundError";
import PressArchivPage from "../components/press/PressArchivePage";
import { ApiResult } from "../lib/CmsApi";
import Pagination from "../components/common/Pagination";
import PageProps from "../lib/models/pageProps";
type Props = ApiResult<"listPressReleases"> & { page: number };
export default function PressArchiveP(props: Props) {
  return <PressArchivPage {...props} />;
}

PressArchiveP.getInitialProps = async ({
  api,
  query
}: InitialPropsContext): PageProps<Props> => {
  const page = (query.page && parseInt(query.page as string, 10) - 1) || 0;
  const content = await api
    .listPressReleases({
      ...Pagination.parsePageToQuery(page),
      orderBy: "date",
      order: "desc",
      xRichtextFormat: "plaintext"
    })
    .catch(() => ({ total: 0, items: [] }));
  if (!content) throw new PageNotFoundError();

  return { ...content, page };
};
